import { useEffect, useRef, useState } from "react";
import { trans } from "utils/helpers";
import { getPersonApi } from "./api";

interface PersonPropsType {
  label?: string,
  hasBorder?: boolean,
  required?: boolean,
  value?: string,
  name: any,
  mode?: string,
  resetForm?: any,
  Change?: (e) => void,
  setPerson?: (e) => void,
  setShowPersonForm: (e) => void,
}

export const PersonDictionaryWithAdd = ({
  setShowPersonForm,
  label,
  name,
  hasBorder,
  value,
  mode,
  required,
  resetForm,
  Change,
  setPerson
}: PersonPropsType) => {
  const [personsList, setPersonsList] = useState<any>();
  const [valueName, setValueName] = useState<any>();
  const [flag, setFlag] = useState(false);
  const [show, setShow] = useState(false);
  const [validat, setValidat] = useState(false);
  const [rquird, setRquird] = useState(false);
  const [count, setCount] = useState<number>(2);
  const inputRef = useRef<any>();
  const inputIdRef = useRef<any>();
  const PersonRef = useRef<any>(personsList);
  const validRef = useRef<any>(false);
  const countRef = useRef<any>(2)

  let optionList: any = []

  async function getPersonListAsync(search, id) {
    try {
      const res = await getPersonApi(search, id);
      if (id && res[id]) {
        // Handle new response format
        const personData = res[id];
        const displayName = personData.Description || personData.Title || id;
        setValeu(displayName, id)
       setPerson&& setPerson(personData)
        setValueName(displayName)
      }
      setPersonsList({ ...res })
      PersonRef.current = { ...res }
      setFlag(!flag)
    } catch (err: any) {

    }
  }

  const Auto = (e) => {
    validRef.current = false
    setValidat(false)
    setRquird(false)
    setShow(true)
    getPersonListAsync(e.target.value, "")
    setFlag(!flag)
  }

  function userSelecter() {
    const personId = Object.keys(personsList)[countRef.current];
    const personData = personsList[personId];
    const displayName = typeof personData === 'string' 
      ? personData 
      : (personData.Description || personData.Title || personId);
    
    setValeu(displayName, personId)
    setShow(false)
  }

  const kydown = (event) => {
    if ((event.key === "ArrowDown")) {
      if (countRef.current < optionList.length - 1) {
        countRef.current = countRef.current + 1;
      } else {
        countRef.current = 0;
      }
    }

    if (event.key === "ArrowUp") {
      if (countRef.current > 0) {
        countRef.current = countRef.current - 1;
      } else {
        countRef.current = optionList.length - 1;
      }
    }
    document.getElementById("personsListIndex" + countRef.current)?.scrollIntoView({ behavior: "smooth" })
    setCount(countRef.current)
    if (event.key === "Enter") {
      userSelecter()
    }
  }

  const CheckPerson = async (e) => {
    setTimeout(() => {
      if (!validRef.current) {
        if (personsList != undefined && Object.values(personsList).length == 1) {
          const personId = Object.keys(personsList)[0];
          const personData = personsList[personId];
          const displayName = typeof personData === 'string' 
            ? personData 
            : (personData.Description || personData.Title || personId);
          
          setValeu(displayName, personId)
          e.target.setCustomValidity("");
        } else {
          if (inputRef.current) {
            setValeu(null, null)
          }
          if (inputRef?.current?.value.length > 0 && inputRef?.current?.value != "") {
            e.target.setCustomValidity(trans("Msg_Validation_ValueIsIncorrect"));
            setValidat(true);
            e.target.reportValidity();
          }
          setPerson && setPerson(null);
        }
      }
    }, 200);
    await delay(200)
    if (!document.activeElement?.className.includes("")) {
      setShow(false)
    }
  }

  const delay = (duration) =>
    new Promise(resolve => setTimeout(resolve, duration));

  const setValeu = (newValue, id) => {
    if (inputIdRef != null && inputIdRef.current != null) {
      validRef.current = true
      inputRef.current.value = newValue;
      inputIdRef.current.value = id;
      PersonRef.current = null;
      ((value == null && id) || id != value) ? Change && Change({ [name]: newValue }) : Change && Change({ [name]: null });

      setPersonsList(null)
      setFlag(!flag)
      inputRef.current.setCustomValidity("")
      
      // Pass complete person data if available
      if (setPerson && personsList && personsList[id]) {
        const personData = personsList[id];
        if (typeof personData === 'object') {
          setPerson(personData)
        } else {
          setPerson({ Id: id, Name: newValue })
        }
      } else if (setPerson) {
        setPerson({ Id: inputIdRef.current.value, Name: inputRef.current.value })
      }
      
      setValidat(false)
    }
  }

  useEffect(() => {
    if (value) {
      getPersonListAsync(null, value)
    } else if (value == null) {
      setValueName(null)
    }
  }, [value]);

  useEffect(() => {
    if (show) {
      document.addEventListener('keydown', kydown);
      document.body.addEventListener("click", clickToclose)
    }
    return () => {
      document.removeEventListener("keydown", kydown);
      document.body.removeEventListener('click', clickToclose)
    }
  }, [show, optionList])

  function clickToclose(e) {
    let input = document.querySelector("#browser" + name);
    if (e.target.id !== input?.id) {
      setShow(false);
    }
  }

  // Create option list with proper display names
  if (personsList) {
    optionList = Object.entries(personsList).map(([id, data]:any) => {
      if (typeof data === 'string') {
        return { id, displayName: data };
      } else {
        return {
          id,
          displayName: data.Description || data.Title || id,
          data
        };
      }
    });
  }

  return (
    <>
      <div className="text-box col-11">
        <label htmlFor={`browser${name}`} className="text-box__label">
          {trans(label ? label : "ChoosePerson")}
        </label>
        {required && <span className="text-box__required-sign-for-label text-danger">*</span>}
        <input required={required} defaultValue={value && value} name={name} className="d-none" ref={inputIdRef} />
        <input
          required={required}
          onBlur={CheckPerson}
          defaultValue={valueName}
          autoComplete="off"
          onFocus={(e) => { setShow(true); Auto(e) }}
          ref={inputRef}
          list="PersonList"
          name="browser"
          className="text-box__box form-control"
          id={"browser" + name}
          onMouseDown={(e) => e.stopPropagation()}
          onChange={Auto}
          disabled={mode != "create" ? true : false}
        />
        {
          show &&
          <div tabIndex={-1} className={`text-box__sub-menu mt-1`}>
            {optionList && optionList.map((item, index) => {
              return (
                <div
                  id={"personsListIndex" + index}
                  style={{ color: item.id.includes("NewPerson") ? "#0d6efd" : "unset" }}
                  className={`${count == index ? "text-box__sub-menu-option-active" : "text-box__sub-menu-option"}`}
                  onClick={() => { setValeu(item.displayName, item.id) }}
                  key={item.id}
                >
                  {item.displayName}
                </div>
              )
            })}
          </div>
        }
        <div className="text-box__msg-wrapper">
          {required && <span className={`${validat ? "show-msg" : "hide-msg"} text-box__required-msg text-danger`}>{trans("Msg_Validation_ValueIsIncorrect")}</span>}
          {required && <span className={`${rquird ? "show-msg" : "hide-msg"} text-box__required-msg text-danger`}>{trans("Msg_Validation_ValueIsRequired", [""])}</span>}
        </div>
      </div>
    </>
  )
}